import { useSlots as g, computed as f, openBlock as e, createElementBlock as i, normalizeClass as l, createBlock as o, withCtx as k, createVNode as y, createCommentVNode as n, toDisplayString as r, renderSlot as x, unref as w } from "vue";
import h from "../../atoms/icon/icon-frame.vue.js";
import S from "../../atoms/icon/icon.vue.js";
import { useTracking as z } from "../../composables/useTracking.js";
import v from "../link/link.vue.js";
/* empty css                    */
const T = {
  key: 0,
  class: "ds-text"
}, d = "left", D = "center", C = /* @__PURE__ */ Object.assign({
  name: "DsCardTextIcon"
}, {
  __name: "card-text-icon",
  props: {
    /**
     * Icon prop, required
     */
    icon: {
      type: [Object, null],
      default: null
    },
    /**
     * Title, required
     */
    title: {
      type: String,
      default: ""
    },
    /**
     * Card text, optional if default slot is present it will take precedence
     */
    text: {
      type: String,
      default: ""
    },
    /**
     * Link, optional
     * @property {string} link.title - link title
     * @property {string} link.url - link href value
     * @property {boolean} link.openInNewWindow - open the link in a new window
     * @property {boolean} link.nuxt - renders as nuxt link
     */
    link: {
      type: Object,
      default: null,
      validator: (t) => ["title", "url", "openInNewWindow", "nuxt"].every((a) => a in t)
    },
    /**
     * Card Alignment
     * Possible values are: 'left' and 'center'.
     */
    alignment: {
      type: String,
      default: d,
      validator: (t) => [d, D].includes(t)
    },
    /**
     * Card title size, optional.
     * renders the title in a bigger font size.
     */
    withTitleSizeLarge: {
      type: Boolean,
      default: !1
    },
    /**
     * Card icon frame size, optional.
     * renders the icon in a bigger frame.
     */
    iconFrameSize: {
      type: String,
      default: "40"
    }
  },
  setup(t) {
    const { trackingDataProvided: a } = z(), s = t, m = g(), u = f(() => !!m.default || !!s.text);
    return (c, E) => (e(), i("div", {
      class: l({ [`ds-text-align-${t.alignment}`]: t.alignment })
    }, [
      t.icon ? (e(), o(h, {
        key: 0,
        "align-x": t.alignment,
        class: l({ "ds-card-text-icon__icon--center": t.alignment === "center" }),
        size: t.iconFrameSize
      }, {
        default: k(() => [
          y(S, {
            category: t.icon.category,
            name: t.icon.name,
            class: "ds-color-green"
          }, null, 8, ["category", "name"])
        ]),
        _: 1
      }, 8, ["align-x", "class", "size"])) : n("", !0),
      t.title ? (e(), i("h4", {
        key: 1,
        class: l(["ds-margin-top-24", [t.withTitleSizeLarge ? "ds-heading-small" : "ds-heading-xsmall"]])
      }, r(t.title), 3)) : n("", !0),
      u.value ? (e(), i("div", {
        key: 2,
        class: l([t.title ? "ds-margin-top-12" : "ds-margin-top-24"])
      }, [
        x(c.$slots, "default", {}, () => [
          t.text ? (e(), i("p", T, r(t.text), 1)) : n("", !0)
        ])
      ], 2)) : n("", !0),
      t.link ? (e(), o(v, {
        key: 3,
        "tracking-data": { "component-name": c.$options.name, text: t.link.title, title: t.title, ...w(a) },
        url: t.link.url,
        "lazy-url-endpoint": t.link.lazyUrlEndpoint,
        "open-in-new-window": t.link.openInNewWindow,
        nuxt: t.link.nuxt,
        content: t.link.title,
        "icon-right": { category: "arrows", name: "chevron-right-small" },
        class: "ds-margin-top-24"
      }, null, 8, ["tracking-data", "url", "lazy-url-endpoint", "open-in-new-window", "nuxt", "content"])) : n("", !0)
    ], 2));
  }
}), b = C;
export {
  b as default
};
